export default function SecurityGroupsViewAssetsController(
  $uibModal,
  $log,
  $state,
  $scope,
  $filter,
  securityGroupsService,
  equipmentRepository,
  gettextCatalog,
) {
  'ngInject';

  $scope.resourceUrl = securityGroupsService.getResourceUrl();
  $scope.animationsEnabled = true;
  $scope.existingEquips = [];
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.successFlag = false;

  $scope.equipments = []; //list of equipments to send to the database
  $scope.postRemoval = [];
  $scope.removals = [];
  $scope.removeFlags = {};
  $scope.filteredEquipmentList = [];
  $scope.equipmentByPage = [];
  $scope.search = {};
  $scope.search.text = '';
  $scope.search.previousText = '';
  $scope.loading = true;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;
  var orderBy = $filter('orderBy');

  //Sort filteredEquipmentList
  $scope.orderEquipmentList = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
    GTM_AssetsChanged('securityAssetsOrderChanged');
  };

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 20;
  $scope.maxSize = 3;

  //applyFilter searchs the equipments[] for anything matching the search input.
  $scope.applyFilter = function () {
    if ($scope.search.previousText === $scope.search.text) return;
    $scope.filteredEquipmentList = $filter('filter')($scope.equipments, $scope.search.text);
    $scope.search.previousText = $scope.search.text;
    GTM_AssetsChanged('securityAssetsFiltered');
  };

  $scope.initializeEquipments = function () {
    $scope.existingEquips = $scope.$parent.group.resources.slice();
    if (!$state.$current.parent.self.ncyBreadcrumbLabel) {
      $state.$current.parent.self.ncyBreadcrumbLabel = $scope.$parent.group.name;
    }
    $scope.equipments = $scope.existingEquips.slice();
    var existingIds = {
      criteria: {
        ids: [],
      },
    };
    for (var i = 0; i < $scope.equipments.length; i++) {
      existingIds.criteria.ids.push($scope.equipments[i].id);
      $scope.removeFlags[$scope.equipments[i].id] = false;
    }
    if (existingIds.criteria.ids.length > 0) {
      equipmentRepository.postEquipmentListByIds(existingIds).then(
        function (response) {
          $scope.loading = false;
          $scope.existingEquips = response.data.slice();
          $scope.equipments = $scope.existingEquips.slice();
          $scope.postRemoval = $scope.existingEquips.slice();
          $scope.filteredEquipmentList = $scope.equipments.slice();
        },
        function (error) {
          var errorMsg = gettextCatalog.getString('An error occurred while retrieving Asset info');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.loading = false;
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
        },
      );
    } else {
      $scope.loading = false;
    }
    GTM_AssetsChanged('securityAssetsLoaded');
  };

  if ($scope.$parent.group) {
    //if group.base is already loaded, the group and its resources will be available
    $scope.initializeEquipments();
  }
  $scope.$on('groupLoaded', function (event) {
    //listen for event broadcasted by group.base on pageload to know when the group and its properties have been retrieved
    $scope.initializeEquipments();
  });

  $scope.open = function (size) {
    var modalScope = $scope.$new();
    modalScope.modalTitle =
      gettextCatalog.getString('Select Assets for Security Group: ') + $scope.group.name;

    $scope.resetFlags();
    var modalInstance = $uibModal.open({
      animation: $scope.animationsEnabled,
      template: require('../../../../../components/assetpicker/asset.multi.picker.html'),
      controller: 'AssetMultiPickerController',
      size: 'lg',
      scope: modalScope,
      resolve: {
        singleSelect: false,
        requiresSelection: false,
        maxSelection: function () {
          return 0;
        },
        selectedAssets: function () {
          var selected = {};

          if ($scope.equipments) {
            for (var i = 0; i < $scope.equipments.length; i++) {
              var e = $scope.equipments[i];
              selected[e.id] = e;
            }
          }
          return selected;
        },
      },
    });

    modalInstance.result.then(
      function (selectedAssets) {
        var changes = [];
        var changeResult = $scope.equipments.slice();
        for (var key in selectedAssets.result) {
          var alreadyPicked = false;
          for (var i = 0; i < $scope.equipments.length; i++) {
            if (key === $scope.equipments[i].id) {
              alreadyPicked = true;
              break;
            }
          }
          if (!alreadyPicked) {
            changeResult.push(selectedAssets.result[key]);
            $scope.applyChange(
              {
                op: 'add',
                value: {
                  resource: $scope.resourceUrl + key,
                },
              },
              changes,
            );
          }
        }
        for (var i = 0; i < changeResult.length; i++) {
          var remove = true;
          for (var key in selectedAssets.result) {
            if (key === changeResult[i].id) {
              remove = false;
              break;
            }
          }
          if (remove) {
            $scope.applyChange(
              {
                op: 'remove',
                value: {
                  resource: $scope.resourceUrl + changeResult[i].id,
                },
              },
              changes,
            );
            changeResult.splice(i, 1);
            i--;
          }
        }
        $scope.saveEquipments(changeResult, changes);
      },
      function () {
        $log.info(
          gettextCatalog.getString('Modal dismissed at: {{date}}', {
            date: new Date(),
          }),
        );
      },
    );
  };

  $scope.toggleAnimation = function () {
    $scope.animationsEnabled = !$scope.animationsEnabled;
  };

  $scope.saveEquipments = function (newEquipmentList, changeset) {
    if (changeset.length == 0 || $scope.sending) {
      return;
    }
    $scope.errorFlag = false;
    var data = changeset;
    $scope.sending = true;

    securityGroupsService.patchEquipmentUserUpdate($scope.securityGroupId, data).then(
      function (response) {
        if (newEquipmentList) {
          $scope.equipments = newEquipmentList.slice();
        }
        $scope.$parent.group.resources = $scope.equipments.slice();
        $scope.existingEquips = $scope.equipments.slice();
        $scope.filteredEquipmentList = $scope.equipments.slice();
        $scope.checkRemovals();
        $scope.applyFilter();
        $scope.orderEquipmentList($scope.predicate, false);
        $scope.successFlag = true;
        $scope.sending = false;
      },
      function (error) {
        var errorMsg = gettextCatalog.getString('An error occurred while editing Asset');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.sending = false;
      },
    );
    return true;
  };

  $scope.toggleRemoval = function (equip) {
    $scope.resetFlags();
    for (var i = 0; i < $scope.postRemoval.length; i++) {
      if ($scope.postRemoval[i].id === equip.id) {
        $scope.postRemoval.splice(i, 1);
        $scope.applyChange(
          {
            op: 'remove',
            value: {
              resource: $scope.resourceUrl + equip.id,
            },
          },
          $scope.removals,
        );
        GTM_AssetsChanged('securityAssetSelected');
        return;
      }
    }
    //if we're toggling the checkbox off, put that equipment back into the post-removal list
    $scope.postRemoval.push(equip);
    $scope.applyChange(
      {
        op: 'add',
        value: {
          resource: $scope.resourceUrl + equip.id,
        },
      },
      $scope.removals,
    ); //will cancel out the "remove" operation for that equip
    GTM_AssetsChanged('securityAssetDeselected');
  };

  $scope.checkRemovals = function () {
    for (var i = 0; i < $scope.equipments.length; i++) {
      //initialize checkbox models for new equipment
      var existed = false;
      for (var key in $scope.removeFlags) {
        if (key === $scope.equipments[i].id) {
          existed = true;
          break;
        }
      }
      if (!existed) {
        $scope.removeFlags[$scope.equipments[i].id] = false;
        $scope.postRemoval.push($scope.equipments[i]);
      }
    }
    $scope.removals = [];
    for (var key in $scope.removeFlags) {
      //clear checkbox models and changes (if necessary) for removed equipment
      var exists = false;
      for (var i = 0; i < $scope.equipments.length; i++) {
        if (key === $scope.equipments[i].id) {
          exists = true;
          break;
        }
      }
      if (!exists) {
        for (var i = 0; i < $scope.postRemoval.length; i++) {
          if ($scope.postRemoval[i].id === key) {
            $scope.postRemoval.splice(i, 1);
            break;
          }
        }
        delete $scope.removeFlags[key];
      }
      if ($scope.removeFlags[key]) {
        $scope.applyChange(
          {
            op: 'remove',
            value: {
              resource: $scope.resourceUrl + key,
            },
          },
          $scope.removals,
        );
      }
    }
  };

  $scope.applyChange = function (newChange, changeset) {
    for (var i = 0; i < changeset.length; i++) {
      //handle behaviour when multiple changes requested for same resource
      if (
        changeset[i].value &&
        changeset[i].value.resource.split('/')[3] === newChange.value.resource.split('/')[3]
      ) {
        if (changeset[i].op === newChange.op) {
          //only apply one add or remove per resource
          return;
        } else {
          //if ops are different, changes will cancel out (ie. adding and removing a resource in the same request will have no net effect)
          changeset.splice(i, 1);
          return;
        }
      }
    }
    changeset.push(newChange);
  };

  $scope.resetFlags = function () {
    $scope.errorFlag = false;
    $scope.successFlag = false;
  };

  $scope.pageChanged = function () {
    GTM_AssetsChanged('securityAssetsPageChanged');
  };

  function GTM_AssetsChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.equipments.length,
        totalFiltered: $scope.filteredEquipmentList.length,
        totalSelected: $scope.removals.length,
        pageNumber: $scope.currentPage,
        orderBy: $scope.predicate,
        sortDirection: $scope.reverse ? 'descending' : 'ascending',
      },
    });
  }
}
